import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';
import { map } from 'rxjs';
import { UrlResolverService } from '../../shared/services/url/url-resolver.service';

@Injectable({
    providedIn: 'root'
})
export class SeedDataService {
    private readonly urlResolver = inject(UrlResolverService);
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    pcxQueryUrl: string = this.urlResolver.getPcxQueryUrl();
    pcxCommandUrl: string = this.urlResolver.getPcxCommandUrl();
    constructor(private http: HttpClient) {}

    public getInsuranceCompanyData() {
        const uri = this.pcxQueryUrl + `/GetInsuranceCompanySeed`;
        return this.http.post(uri, { EntityName: 'SeedData' }, SCConfig.HttpCommonOptions).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    public activeAndInactiveInsuranceCompany(payload: any) {
        const uri = this.pcxCommandUrl + `ActiveAndInactiveInsuranceCompany`;
        return this.http
            .post(uri, payload, {
                headers: this.header,
                withCredentials: true,
                observe: 'response'
            })
            .pipe(
                map((response: any) => {
                    return response;
                })
            );
    }

    public getGenericEntityData(entityName: string, filterString: string) {
        const payload = {
            EntityName: entityName,
            SortBy: `{CreateDate: 1}`,
            FilterString: filterString,
            PageNumber: 0,
            PageSize: 100,
            UsePagination: false
        };
        return this.http
            .post(this.pcxQueryUrl + 'GetGenericEntityData', payload, {
                headers: this.header,
                withCredentials: true,
                observe: 'response'
            })
            .pipe(
                map((response: any) => {
                    return response.body;
                })
            );
    }
}
